let serviceArea = resolve => require(['@/views/serviceArea/Index.vue'], resolve)
const routes = [{
  path: 'serviceArea',
  component: serviceArea,
  name: 'serviceArea',
  meta: {
    title: '高速服务区升级方案'
  },
}];

export default routes